package com.trevorwiebe.timesheet.core.presentation.common

import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.asPaddingValues
import androidx.compose.foundation.layout.navigationBars
import androidx.compose.material3.adaptive.navigationsuite.NavigationSuiteType
import androidx.compose.runtime.Composable
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.max

@Composable
fun botPadding(): Dp {
    val navInset = WindowInsets.navigationBars.asPaddingValues().calculateBottomPadding()
    // NavigationSuiteScaffold reserves space for the bar/rail itself, so only a small
    // aesthetic gap is needed when the bar is shown; otherwise keep the gesture-nav inset.
    return if (LocalNavSuiteType.current == NavigationSuiteType.NavigationBar) {
        16.dp
    } else {
        max(16.dp, navInset)
    }
}
